import { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Adds hoverable state and hooks to any component. 😊👌
 * Stop repeating the same pattern to add hover control to your components.
 *
 * Usage example with render props pattern:
 *
 * <Hoverable>
 *     {(isHovered, onMouseEnter, onMouseLeave) => (
 *         <MyComponent
 *             propForIsHovered={isHovered}
 *             onMouseEnter={onMouseEnter}
 *             onMouseLeave={onMouseLeave}
 *         />
 *     )}
 * </Hoverable>
 */
export default class Hoverable extends Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
    };
    state = {
        isHovered: false,
    };
    handleMouseEnter = () => {
        this.setState({ isHovered: true });
    };
    handleMouseLeave = () => {
        this.setState({ isHovered: false });
    };
    render() {
        return this.props.children(this.state.isHovered, this.handleMouseEnter, this.handleMouseLeave);
    }
}
